var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "rbvp-rules-editor" },
    [
      _c("input", {
        ref: "ruleFileInput",
        staticClass: "rbvp-hidden-file-input",
        attrs: { type: "file", accept: ".txt,text/plain" },
        on: { change: _vm.handleRuleFileChange },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-rules-toolbar" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "rbvp-rules-toolbar-actions" }, [
          _c(
            "div",
            { staticClass: "rbvp-rules-toolbar-primary" },
            [
              _c(
                "VButton",
                {
                  attrs: {
                    type: _vm.state.hasUnsavedRulesChanges
                      ? "primary"
                      : undefined,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.actions.saveRules()
                    },
                  },
                },
                [_vm._v("\n          保存主规则\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rbvp-rule-create-actions" },
            [
              _c(
                "VButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.actions.exportRules()
                    },
                  },
                },
                [_vm._v("导出主规则")]
              ),
              _vm._v(" "),
              _c(
                "VButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.triggerRuleFileImport()
                    },
                  },
                },
                [_vm._v("导入主规则")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("TextArea", {
        staticClass: "rbvp-textarea",
        attrs: {
          text: _vm.state.rulesText,
          rows: "12",
          placeholder:
            "示例:&#10;UP, 123456, rememberVideoSpeed:1.5&#10;TAG, 教程, rememberVideoSpeed:MAX&#10;RULE-SET, study-list, rememberVideoSpeed:MEMORY_LOCAL&#10;FINAL, rememberVideoSpeed:MIN",
        },
        on: { change: _vm.updateRulesText },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-rules-toolbar-meta" }, [
      _c("span", [_vm._v("文本视图保留逐行编辑能力")]),
      _vm._v(" "),
      _c("span", [_vm._v("切回可视化视图时会重新解析当前文本")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }